import { Text, Box, Button, Icon, Image, Skeleton } from '@betty/moonlight';
import { StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { AuthNavigatorParamsList } from '../navigators/AuthNavigator/AuthNavigator.types';
import {
  fetchPromo,
  selectLandingPromoByType,
  selectLandingPromosDataState,
} from '../state';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { useEffect } from 'react';

function IntroScreen() {
  const dispatch = useDispatch();
  const navigation =
    useNavigation<StackNavigationProp<AuthNavigatorParamsList>>();

  const landingPromo = useSelector(selectLandingPromoByType('Welcome'));
  const landingPromosDataState = useSelector(selectLandingPromosDataState);

  useEffect(() => {
    if (landingPromosDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, landingPromosDataState]);

  return (
    <Box flex={1}>
      <Image
        position="absolute"
        top="space-0"
        left="space-0"
        width="100%"
        height="100%"
        contentFit="cover"
        name="auth.IntroBackground"
      />
      <LinearGradient
        colors={['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.5)', 'rgba(0, 0, 0, 1)']} // Black shadow to transparent
        style={StyleSheet.absoluteFill}
      />
      <Box
        flex={1}
        flexDirection="column"
        justifyContent="space-between"
        paddingHorizontal="space-600"
        paddingTop="safe-area-inset-top"
        paddingBottom="safe-area-inset-bottom"
      >
        <Box
          paddingVertical="space-100"
          alignItems="center"
          backgroundColor="accentBackground"
        >
          <Icon name="bettyLogo" height={48} width={109} />
        </Box>
        <Box gap="space-600">
          <Text
            textAlign="center"
            variant="h4"
            gradient="darkSurfaceAccent"
            locKey="slogan"
            locNS="auth"
          />
          <Box minHeight={42}>
            {landingPromo ? (
              <Text
                textAlign="center"
                variant="body-m"
                color="darkSurfacePrimary"
              >
                {landingPromo.shortDescription}
              </Text>
            ) : (
              <Skeleton
                backgroundColor="backdropPrimary"
                width="100%"
                height={42}
              />
            )}
          </Box>
          <Box gap="space-300">
            <Button
              locKey="login"
              locNS="auth"
              size="large"
              onPress={() => navigation.navigate('LoginScreen')}
            />
            <Button
              locKey="join"
              locNS="auth"
              variant="secondary"
              size="large"
              onPress={() => navigation.navigate('RegistrationScreen')}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default IntroScreen;
